import { LevelGranulometry, LevelGranulometryInitialEntries } from '../../LevelGranulometry';
import { TopLevelSpecification } from '../../../../specification/levels/TopLevelSpecification';

export const isGroundLevel = (
  level: LevelGranulometryInitialEntries | TopLevelSpecification | LevelGranulometry
): boolean => level.level === 0;
